// Mapeamento de área do sistema -> subdomínio de produção (speedorder.com.br)
const ROOT_DOMAIN = 'speedorder.com.br';

const AREA_PREFIXES = {
  admin: 'app',
  cliente: 'cliente',
  operador: 'operador',
  hub: 'hub',
  parceiro: 'parceiro',
};

// Retorna a área atual com base no hostname, ou null se o host não for
// um dos subdomínios conhecidos (localhost, preview da Vercel, etc.) —
// nesse caso não aplicamos nenhuma restrição de rota.
export function getArea() {
  const prefix = window.location.hostname.split('.')[0];
  const entry = Object.entries(AREA_PREFIXES).find(([, p]) => p === prefix);
  return entry ? entry[0] : null;
}

export function getAreaUrl(area, path = '/') {
  const prefix = AREA_PREFIXES[area];
  return `${window.location.protocol}//${prefix}.${ROOT_DOMAIN}${path}`;
}

// Navega para `path` dentro da área informada. Se já estivermos nela (ou em
// ambiente sem subdomínio mapeado, ex: localhost) usa o react-router normal;
// caso contrário, troca de subdomínio via navegação de página inteira.
export function navigateToArea(navigate, area, path) {
  const current = getArea();
  if (current === null || current === area) {
    navigate(path);
  } else {
    window.location.href = getAreaUrl(area, path);
  }
}
